import { render, staticRenderFns } from "./PeopleAutocomplete.vue?vue&type=template&id=701db2a0"
import script from "./PeopleAutocomplete.vue?vue&type=script&lang=js"
export * from "./PeopleAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports